import {FunctionComponent, InputHTMLAttributes} from 'react';
import clsx from 'clsx';
import {twMerge} from 'tailwind-merge';
import {useFormControlContext} from '@/components/form/form-control/form-control';

type ElementProps = InputHTMLAttributes<HTMLInputElement> & {
  'label'?: string;
  'data-testvalue'?: string;
};

const Radio: FunctionComponent<ElementProps> = ({label, 'data-testvalue': dataTestValue, ...props}) => {
  const {isInError, isDisabled, hasWarning} = useFormControlContext();

  const mergedLabelClasses = clsx(
    'flex cursor-pointer items-center gap-2',
    (isDisabled || props.readOnly) && 'cursor-not-allowed opacity-50',
  );

  const inputClasses = clsx(
    'peer relative size-5 cursor-pointer appearance-none rounded-xl border border-violet transition-all checked:border-violet checked:bg-violet',
    isInError && 'border-red',
    hasWarning && 'border-yellow-600',
  );

  return (
    <label aria-disabled={isDisabled} className={twMerge(mergedLabelClasses)} data-testvalue={dataTestValue}>
      <div className="relative leading-none">
        <input className={twMerge(inputClasses)} type="radio" disabled={isDisabled} {...props} />

        <div className="absolute left-0.5 top-0.5 z-20 size-4 rounded-xl border-2 border-white bg-violet opacity-0 transition-opacity peer-checked:z-10 peer-checked:opacity-100"></div>
      </div>

      <div className="leading-none text-charcoal">{label}</div>
    </label>
  );
};

export default Radio;
